import * as React from 'react';
import { PrimaryButton, DefaultButton, Panel, PanelType } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const ConfirmDestructiveOperation = props => {
  const actionButtonStyles = {
    root: [{
      color: '#ffffff',
      backgroundColor: '#ac0303'
    }],
    iconHovered: [{
      color: '#eeeeee',
      backgroundColor: '#a13535'
    }]
  };
  const onAddPanelRenderFooterContent = () => {
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(DefaultButton, {
        onClick: props.onCancelClick,
        style: {
          marginRight: '8px'
        },
        children: "Cancel"
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        styles: actionButtonStyles,
        onClick: props.onConfirmClick,
        children: props.actionButtonName || 'Yes'
      })]
    });
  };
  const panelStyles = {
    main: [{
      borderLeft: 'solid 10px #ac0303',
      color: '#ffffff',
      backgroundColor: '#1b1b1b'
    }],
    headerText: [{
      color: '#ffffff'
    }],
    closeButton: [{
      color: '#ffffff'
    }]
  };
  return /*#__PURE__*/_jsx(Panel, {
    isOpen: props.isOpen,
    type: PanelType.smallFixedFar,
    onDismiss: props.onCancelClick,
    headerText: "Are you sure?",
    closeButtonAriaLabel: "Close",
    onRenderFooterContent: onAddPanelRenderFooterContent,
    styles: panelStyles,
    children: props.subText
  });
};